import React from "react";
import {busRouteService} from "../../jwt/_services/eventx/busRouteService";

export const busRouteProvider = {
    getOptions,
    getItem,
};

async function getOptions(fbDataBaseId = null) {
    try {
        const listItems = await busRouteService.search(0,100, {
            fbDataBase : {  id : fbDataBaseId },
            item : { code: null, }
        } );

        return listItems.data.map((itemData) => {
            return (
                {
                    id: itemData.id,
                    value: itemData.code,
                    label: <div><label>{itemData.name}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id) {
    try {
        const item = await busRouteService.search(0,10, {
            fbDataBase : {  id : null },
            item : { id: id, }
        } );
        let show = item && item.name ? item.name : 'Something went wrong';
        return (
            {
                id: item.id,
                value: show,
                label: <div><label>{show}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}